import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { loadFireAssumptions, saveFireAssumptions, computeFireProjectionAction } from '@renenet/shared/src/actions/fire';
import { initNetWorthSummary } from '@renenet/shared/src/actions/networth';
import { formatCurrencyByLocale } from '@renenet/shared/src/utils/currencyUtils';

import FireAssumptionsForm from './FireAssumptionsForm';
import FireMetrics from './FireMetrics';
import FireProjectionChart from './FireProjectionChart';

function mapStateToProps(state) {
  return {
    currencyInfo: state.currencyInfo,
    netWorthInfo: state.netWorthInfo,
    userInfo: state.userInfo,
    fireInfo: state.fireInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadFireAssumptions: () => dispatch(loadFireAssumptions()),
    initNetWorthSummary: currencyInfo => dispatch(initNetWorthSummary(currencyInfo)),
    saveFireAssumptions: assumptions => dispatch(saveFireAssumptions(assumptions)),
    computeFireProjection: (assumptions, currentNetWorth) =>
      dispatch(computeFireProjectionAction(assumptions, currentNetWorth)),
  };
}

class Fire extends Component {
  async componentDidMount() {
    await this.props.initNetWorthSummary(this.props.currencyInfo);
    this.props.loadFireAssumptions();
  }

  componentDidUpdate(prevProps) {
    const { fireInfo, netWorthInfo } = this.props;
    const assumptionsJustLoaded =
      !prevProps.fireInfo.assumptionsLoaded && fireInfo.assumptionsLoaded;
    const netWorthJustLoaded =
      prevProps.netWorthInfo.currentNetWorth === 0 && netWorthInfo.currentNetWorth !== 0;

    if (
      (assumptionsJustLoaded || netWorthJustLoaded) &&
      fireInfo.assumptionsLoaded &&
      fireInfo.assumptions.annualSpending
    ) {
      this.props.computeFireProjection(fireInfo.assumptions, netWorthInfo.currentNetWorth);
    }
  }

  render() {
    const { fireInfo, currencyInfo, netWorthInfo, userInfo } = this.props;
    const hasProjection = fireInfo.projection.fireNumber !== null;

    return (
      <Container>
        <Row className="mb-3">
          <Col><h2>FIRE Calculator</h2></Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <h5>Assumptions</h5>
            <p className="text-muted mb-3">
              Current net worth:{' '}
              {netWorthInfo.netWorthSummary === null
                ? <Spinner animation="border" size="sm" />
                : <strong>{formatCurrencyByLocale(currencyInfo.locale, currencyInfo.aggregationCurrency, netWorthInfo.currentNetWorth)}</strong>
              }
            </p>
            {fireInfo.assumptionsLoaded
              ? <FireAssumptionsForm
                  assumptions={fireInfo.assumptions}
                  onSave={this.props.saveFireAssumptions}
                />
              : <Spinner animation="border" size="sm" />
            }
          </Col>
        </Row>
        {hasProjection && (
          <React.Fragment>
            <Row className="mb-2">
              <Col><h5>Your FIRE Metrics</h5></Col>
            </Row>
            <Row className="mb-4">
              <Col>
                <FireMetrics projection={fireInfo.projection} currencyInfo={currencyInfo} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col><h5>Projection</h5></Col>
            </Row>
            <Row>
              <Col>
                <FireProjectionChart
                  projection={fireInfo.projection}
                  currencyInfo={currencyInfo}
                  userInfo={userInfo}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
      </Container>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Fire);
